<template>
  <a href="/" class="logo relative">
    <img src="../../assets/logo.png" alt="logo" />
  </a>
</template>

<style scoped>
.logo {
  width: clamp(135px, 9.375vw, 675px);
  min-width: clamp(135px, 9.375vw, 675px);
  height: clamp(37px, 2.569vw, 185px);
  z-index: 10;
  img {
    width: 100%;
    height: auto;
  }
}
</style>